import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import {
  TICKET_SCAN_BY_ORDER_ID_MUTATION,
  TICKET_SCAN_MUTATION,
  TICKET_UPDATE_MUTATION,
} from "./mutations";
import { TICKET_LIST_QUERY, TICKET_READ_QUERY } from "./queries";
import {
  TicketUpdate,
  TicketUpdateVariables,
  TicketScan,
  TicketScanVariables,
  TicketScanByOrderId,
  TicketScanByOrderIdVariables,
} from "./__generated__/mutations";
import {
  TicketList,
  TicketListVariables,
  TicketRead,
  TicketReadVariables,
} from "./__generated__/queries";

export const useTicketUpdateMutation = makeMutationHook<
  TicketUpdate,
  TicketUpdateVariables
>(TICKET_UPDATE_MUTATION);

export const useTicketScanMutation = makeMutationHook<
  TicketScan,
  TicketScanVariables
>(TICKET_SCAN_MUTATION);

export const useTicketScanByOrderIdMutation = makeMutationHook<
  TicketScanByOrderId,
  TicketScanByOrderIdVariables
>(TICKET_SCAN_BY_ORDER_ID_MUTATION);

export const useTicketListQuery = makeQueryHook<
  TicketList,
  TicketListVariables
>(TICKET_LIST_QUERY);

export const useTicketReadQuery = makeQueryHook<
  TicketRead,
  TicketReadVariables
>(TICKET_READ_QUERY);
